export default __webpack_public_path__ + "i18n/translations/translation-bn.e504a8bf.json";